package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Duplicate commits within half a second should not repeat the same screen-reader sentence. */
internal class StudioAnnouncer(private val now: () -> Long) {
    private var previous = ""
    private var at = Long.MIN_VALUE
    fun commit(message: String): String? {
        val time = now()
        if (message == previous && time >= at && time - at < 500) return null
        previous = message; at = time
        return message
    }
}

/** One region mirrors committed actions; pointer previews never enter the accessibility stream. */
@Composable
internal fun StudioAnnouncement(message: String) {
    Div(attrs = {
        attr("role", "status"); attr("aria-live", "polite"); attr("aria-atomic", "true")
        attr("data-studio-announcer", "")
        style {
            property("position", "absolute"); property("width", "1px"); property("height", "1px")
            property("overflow", "hidden"); property("clip-path", "inset(50%)")
        }
    }) { Text(message) }
}
